/*
 * Event Service.
 */

/**
 * REST CLIENT PER WS DI GESTIONE DELLE KEYWORDS
 */
'use strict';
module.exports = [
  '$rootScope',
  '$resource',
  '$httpParamSerializerJQLike',
  function ($rootScope, $resource, $httpParamSerializerJQLike) {
    var mainConfig = global.ngDroAstralSituationRecordMainConfig;
    var baseEndPointUrl = mainConfig.ApiUrl;
    var sourceEndPointUrl = baseEndPointUrl + 'keyword';

    return $resource(
      baseEndPointUrl,
      {},
      {
        findAll: {
          method: 'GET',
          url: sourceEndPointUrl + '/find-all',
          withCredentials: true,
          isArray: true,
        },

        findAllPaginated: {
          method: 'GET',
          url: sourceEndPointUrl + '/find-all-paginated',
          withCredentials: true,
          params: {
            page: '@page',
            size: '@size',
          },
        },

        getById: {
          method: 'GET',
          url: sourceEndPointUrl + '/:id',
          withCredentials: true,
          params: {
            id: '@id',
          },
        },

        create: {
          method: 'POST',
          url: sourceEndPointUrl,
          withCredentials: true,
          transformRequest: function (data) {
            var json = angular.toJson(data);
            return json;
          },
        },

        update: {
          method: 'PUT',
          url: sourceEndPointUrl,
          withCredentials: true,
          transformRequest: function (data) {
            var json = angular.toJson(data);
            return json;
          },
        },

        delete: {
          method: 'DELETE',
          url: sourceEndPointUrl + '/:id',
          withCredentials: true,
          params: {
            id: '@id',
          },
        },
      }
    );
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/services/keywordsService.js
// module id = 260
// module chunks = 0